import { Ng1StateDeclaration } from '@uirouter/angularjs';

import * as Resolve from '../Resolve';
import { Roles } from '../../common/constants';

const states: Ng1StateDeclaration[] = [{
    name: 'manualInputs',
    url: '/manualInputs/:beginDate/:endDate',
    component: 'wtManualInputsState',
    resolve: {
        auth: Resolve.authResolve,
        connected: Resolve.connectedResolve,
        roles: Resolve.rolesResolve(Roles.manualInputRoles),
        initialDates: Resolve.datesResolve
    },
    params: {
        beginDate: '',
        endDate: ''
    },
    data: {
        visible: false,
        sortingOrder: 8,
        displayName: 'Manual inputs',
        icon: 'fa-keyboard-o',
        editRoles: [Roles.master, Roles.operator],
        editButtonVisibility: () => false,
        subMenu: {
            'type': 'groups',
            subState: 'validation',
            parentName: 'dataEntry'
        },
        subStates: ['logbook', 'spotValues']
    }
}, {
    name: 'spotValues',
    url: '/spotValues/',
    component: 'wtSpotValuesState',
    resolve: {
        auth: Resolve.authResolve,
        connected: Resolve.connectedResolve,
        roles: Resolve.rolesResolve(Roles.manualInputRoles),
    },
    params: {},
    data: {
        visible: false,
        displayName: 'Spot values',
        icon: 'fa-map-pin',
        editButtonVisibility: () => false,
        subMenu: {
            parentName: 'dataEntry'
        },
    }
}];

export default states;